module.exports = __webpack_public_path__ + "static/img/dengyunze.13ae2ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/dengyunze.png
// module id = UAiH
// module chunks = 0